import { useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Drawer } from '@mui/material';

import { useOnClickOutside } from '@flexo/hooks';
import { UpdateCredentialsForm } from '../update-credentials-form/update-credentials-form';

import styles from './right-drawer.module.scss';
import {TotalEstimatedBenefitsDrawerContent} from './drawer-contents/total-estimated-benefits';
import {TotalCostsDrawerContent} from './drawer-contents/total-costs';
import {default as PaymentsListDrawerContent} from './drawer-contents/payments-list';
import { EsriMapComponent } from '@flexo/atoms';
import { useDispatch, useSelector } from 'react-redux';
import { RIGHT_DRAWER } from '@flexo/reducers';

export const RightDrawer = () => {
  const drawerRef = useRef(null);
  const dispatch = useDispatch();
  const rightDrawer = useSelector((state: any) => state.rightDrawer);

  function isChildOf(event) {
    const parentDiv = document.getElementById('right-drawer');
    let targetElement = event.target; // L'elemento che è stato cliccato

    // Itera attraverso i genitori dell'elemento target fino a raggiungere il body
    while (targetElement !== document.body) {
      if (targetElement === parentDiv) {
        return true; // Il target è figlio del parentDiv
      }
      targetElement = targetElement.parentNode; // Vai al genitore dell'elemento target
    }

    return false; // Il target non è figlio del parentDiv
  }

  function checkBackdropClose(ev: any) {
    const classContent = (ev?.target?.className && ev.target.className) || '';
    try {
      if (
        rightDrawer.show === true &&
        classContent?.includes('MuiBackdrop-root') === true &&
        isChildOf(ev) === true
      ) {
        dispatch(RIGHT_DRAWER.HideDrawer());
      }
    } catch (error) {
      console.warn('error', error);
    }
    
  }

  useOnClickOutside(drawerRef, (ev: any) => {
    if (isChildOf(ev) === false) {
      return;
    }

    if (rightDrawer.show === true) {
      dispatch(RIGHT_DRAWER.HideDrawer());
    }
  });

  const getDrawerContent = () => {
    const requiredContent = rightDrawer?.type || '';

    let content = <></>;

    switch (requiredContent) {
      case 'CREDENTIALS_UPDATE_FORM':
        content = <UpdateCredentialsForm />;
      break;
      case 'COMMUNITY_TOTAL_COSTS':
      case 'MEMBER_TOTAL_COSTS':
      case 'SITE_TOTAL_COSTS':
        content = <TotalCostsDrawerContent drawerConfig={ rightDrawer.drawerConfig }/>;
      break;
      case 'COMMUNITY_TOTAL_ESTIMATED_BENEFITS':
      case 'MEMBER_TOTAL_ESTIMATED_BENEFITS':
      case 'SITE_TOTAL_ESTIMATED_BENEFITS':
        content = <TotalEstimatedBenefitsDrawerContent drawerConfig={ rightDrawer.drawerConfig }/>;
        break;
      case 'COMMUNITY_PAYMENTS_LIST':
        content = <PaymentsListDrawerContent type={'overview'} drawerConfig={rightDrawer.drawerConfig} />;
        break;
      case 'INVOICES_PERIOD_DETAILS':
        content = <PaymentsListDrawerContent type={'details'} drawerConfig={ rightDrawer.drawerConfig }/>;
        break;
      case 'EXPANDED_MAP':
        content = (
          <EsriMapComponent
            {...{
              wrapper: 'drawer',
              env: 'web',
            }}
          />
        );
        break;
      default:
        content = <></>;
        break;
    }

    return content;
  };

  function getDrawerClassName() {
    if (rightDrawer?.type === 'INVOICES_PERIOD_DETAILS' || rightDrawer?.type === 'COMMUNITY_PAYMENTS_LIST') {
      return styles.RightDrawer__Invoices;
    }
    if (rightDrawer?.type === 'EXPANDED_MAP') {
      return styles.RightDrawer__Map;
    }
    return styles.RightDrawer;
  }

  return (
    <div
      key={`RightDrawer_${uuidv4()}`}
      ref={drawerRef}
      id="right-drawer"
      onClick={(ev: any) => checkBackdropClose(ev)}
    >
      <Drawer
        open={rightDrawer.show}
        anchor={'right'}
        disablePortal={true}
        disableEnforceFocus
        disableRestoreFocus
      >
        {/* <Drawer open={rightDrawer.show} anchor={'right'}> */}
        <div
          className={getDrawerClassName()}
        >
          {getDrawerContent()}
        </div>
      </Drawer>
    </div>
  );
};

export default RightDrawer;
